import $ from 'jquery';
import { standardAjaxPost } from 'stdjs/standard-ajax';
import { setupMultiSelect } from '../stdjs/multi-select';

export function setupSubsetField({
  selector,
  subsetTogglePostKey,
  multiSelectPostKey,
  onChangeListener,
  onMultiChangeListener,
  onSelectClearListener
}){

  if (!selector){
    return;
  }

  var mulitSelect = null;

  selector.find("input[type='radio']").change(function(e){

      if (onChangeListener){
        onChangeListener(e);
      }

      var showMulti = $(this).attr("data-show-multi") === "true" ? true : false;
      if (showMulti){
          selector.find(".multiselect").removeClass("invisible");
          selector.find(".multiselect").removeClass("h-0");
      } else {
          selector.find(".multiselect").addClass("invisible");
          selector.find(".multiselect").addClass("h-0");
      }
  });

  if (selector.find(".multiselect").length > 0){
    mulitSelect = setupMultiSelect(selector.find(".multiselect"), multiSelectPostKey, onSelectClearListener, onMultiChangeListener);
  }

  function resetSubsetField(){

    selector.find("input[data-default='true']").prop("checked", true);  
    selector.find("input[data-default='true']").trigger("change");

    if (mulitSelect){
      mulitSelect.clearAll();
    }
  }

  function getSelectedToggle(){
    return selector.find("input:checked");
  }

  function getPostData(){

    var selectedToggle = getSelectedToggle();
    var postData =  "&" + subsetTogglePostKey + "=" + selectedToggle.val();

    if (selectedToggle.attr("data-show-multi") === "true"){
      postData += mulitSelect.getPostData();
    }

    return postData;
  }

  function setToggleValue($toggleValue){

    var input = selector.find("input[value='" + $toggleValue + "']");
    if (input.length > 0){
      input.trigger("click");
    }
  }

  function setMultiValue($multiValue){
    selector.find(".multi-select-item[data-id='" + $multiValue + "']").addClass("active");
  }

  function setMultiData($multiData){
    if (mulitSelect){
      mulitSelect.setMultiData($multiData);
    }
  }

  function setMeSelected(){
    setToggleValue("SELECTED");
    selector.find(".multi-select-item[data-me='true']").addClass("active");
  }

  function enableOptions(){
    if (mulitSelect){
      if (mulitSelect.hasMultiSelectItems()){
        selector.find("input[data-show-multi='true']").prop("disabled", false);  
      } else {
        selector.find("input[data-show-multi='true']").prop("disabled", true);  
        selector.find("input[data-show-multi='true']").prop("checked", false);  
        selector.find("input[data-default='true']").prop("checked", true);  
        selector.find(".multiselect").addClass("invisible");
        selector.find(".multiselect").addClass("h-0");
      }
    }
  }

  enableOptions();

  return {
    mulitSelect: mulitSelect,
    resetSubsetField: resetSubsetField,
    getSelectedToggle: getSelectedToggle,
    getPostData: getPostData,
    setToggleValue: setToggleValue,
    setMultiValue: setMultiValue,
    setMultiData: setMultiData,
    setMeSelected: setMeSelected,
    enableOptions: enableOptions,
  }
}

